import "./Nav.css";

const Nav =()=>{

    return(

        <nav id="nav">
            <div>
                <div>
            <img src="/img/logo2.png" alt="" />
            <h3>Hamidovic Edin</h3>
            </div>
            <ul>
                
                <li><a  href="#title">Home</a></li>
                <li><a  href="#leistungen">Leistungen</a></li>
                <li><a  href="#footer">Kontakt</a></li>
            </ul>
            </div>

        </nav>
    )

}

export default Nav